import { useState, useEffect } from 'react';

const usePageTitle = (title) => {
    const [documentTitle, setDocumentTitle] = useState(title);
    useEffect(() => {
        document.title = documentTitle;
    }, [documentTitle]);
    return [documentTitle, setDocumentTitle];
}

export { usePageTitle };